import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MensajesPage } from '../pages/MensajesPage';
import '../styles.css';

const container = document.getElementById('app')!;
createRoot(container).render(
  <StrictMode>
    <MensajesPage />
  </StrictMode>,
);
